import _ from "ES/lib/lodash";
import Ledger from "../../../../marketplace/MyLeadsTab/Ledger";
import React from "ES/lib/react";
import esUtils from "ES/utils/esUtils";
import PackagesForm from "./PackagesForm";
import ServicesTable from "./ServicesTable";
import ProductSaleTable from "./ProductSaleTable";
import AuthedUserSession from "../../../../../utils/AuthedUserSession";
import isEventAccountingLockedForMe from "../../../../../utils/isEventAccountingLockedForMe";
import getOfferStatusForJob, {OFFER_STATII} from "../../../../../utils/getOfferStatusForJob";

let UnscheduledEventEstimatedMonthAndYear = (AuthedUserSession.is_st_family)
    ? require("./UnscheduledEventEstimatedMonthAndYear")
    : null;
let QuickBooks = !AuthedUserSession.is_privatelabel
    ? require("./QuickBooks")
    : null;

module.exports = React.createFactory(React.createClass({
        getInitialState: function () {
            return {
                show_quickbooks: false,
            };
        },

        __toggleQuickbooks: esUtils.wrapPreventDefault(function () {
            this.setState({
                show_quickbooks: !this.state.show_quickbooks
            });
        }),


        render: function () {

            let {event, Displaylists} = this.props;
            let mp_agreement = _.get(event, ["MPAgreement", _.first(event.sids)]);
            let offer_status = getOfferStatusForJob.statusForEvent(event, _.first(event.sids), false);
            let body;
            let read_only = AuthedUserSession.doIHaveAccess.read_or_travel.all(event.sids) || isEventAccountingLockedForMe(event);
            let params = {event, Displaylists, read_only};

            let money_tab_url = "#/marketplace/" + _.first(event.sids) + "/money";


            if (event.is_mp_event) {
                if (_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "offer accepted")) {

                    //MP, ACCEPTED OFFER
                    body = <div>
                        <h2>Job Fees collected through Marketplace
                        </h2>
                        <p className="instruction">
                            These fees were set when the offer was accepted, and are collected for you by eSpeakers.
                        </p>
                        <Ledger
                            event={event}
                            Displaylists={Displaylists}
                            mp_agreement={mp_agreement}
                            display_payments={true}
                        />
                        <div className="text-muted pull-left"><a target="_blank" href="https://espeakers.com/wiki/How_do_I_pay_my_presenter_through_the_Marketplace_platform%3F">How does my client pay? &raquo;</a></div>
                        <div className="text-muted pull-right"><a href={money_tab_url}>Stripe balance &raquo;</a></div>

                        <div className="clearfix"/>

                        <h4 className="section-head">Products</h4>
                        {ProductSaleTable(params)}

                        <h4 className="section-head">Packages</h4>
                        {PackagesForm(params)}
                    </div>;

                } else {
                    body = <div className="text-muted" style={{marginTop:"2em", marginBottom:"2em"}}>
                        Once this Marketplace job has an accepted offer, the price and payments will be displayed here.
                    </div>;
                }
                //only an MP job with an accepted offer should ever be shown on this screen
                // else if (_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "waiting client")) {
                //
                //     //MP, OFFER MADE BUT NOT ACCEPTED YET -- we shouldn't ever get here
                //     body = <div>
                //         <h2>Job Fees
                //         </h2>
                //         <p className="instruction">
                //             The offer is not finalized yet.
                //         </p>
                //         <Ledger
                //             event={event}
                //             Displaylists={Displaylists}
                //             mp_agreement={mp_agreement}
                //             display_payments={false}
                //         />
                //         <div className="text-muted text-right"><a href={money_tab_url}>Stripe balance &raquo;</a>
                //         </div>
                //
                //         <h4 className="section-head">Products</h4>
                //         {ProductSaleTable(params)}
                //
                //         <h4 className="section-head">Packages</h4>
                //         {PackagesForm(params)}
                //     </div>;
                // } else {
                //
                //     //MP, NO OFFER
                //     body = <div>
                //         <h2>Job Fees</h2>
                //         <p style={{fontStyle: "italic"}}>Once an offer has been made, payment details will be displayed here.</p>
                //     </div>;
                // }

            } else {

                //NOT MARKETPLACE
                body = <div>
                    <h2>Services
                        {QuickBooks &&
                        <span className="pull-right">
                    <button className="btn btn-default btn-sm" onClick={this.__toggleQuickbooks}>Copy To QuickBooks</button>
                    </span>
                        }
                    </h2>
                    {ServicesTable(params)}
                    {UnscheduledEventEstimatedMonthAndYear && UnscheduledEventEstimatedMonthAndYear(params)}
                    <h4 className="section-head">Products</h4>
                    {ProductSaleTable(params)}

                    <h4 className="section-head">Packages</h4>
                    {PackagesForm(params)}
                </div>;

            }


            return <div className="Services">
                {body}
                {this.state.show_quickbooks && QuickBooks && QuickBooks({onClose: this.__toggleQuickbooks, event: event})}
            </div>;
        }
    })
);


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/index.js